'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/app/_hooks/use-auth';
import { Spinner } from '@/app/_components/ui/spinner';

export default function DashboardRedirect() {
  const navigate = useNavigate();
  const { user, isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate('/auth/login', { replace: true });
      return;
    }

    const spend = user?.user_info?.spend ?? 0;
    const target = spend > 0 ? '/dashboard/usage' : '/dashboard/quickstart';
    navigate(target, { replace: true });
  }, [isAuthenticated, isLoading, navigate, user]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Spinner className="h-8 w-8" />
    </div>
  );
}
